import { cn } from '@restworld/utils-common';
import { forwardRef, HTMLAttributes } from 'react';

export const ReversedItemsWrapper = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('bg-neutral-700 px-4 py-10 flex items-center gap-4', className)} {...props} />
  )
);
ReversedItemsWrapper.displayName = 'ReversedItemsWrapper';

export const notificationIndicatorStyles =
  'h-6 w-6 rounded-full bg-red-500 grid place-items-center text-neutral-10 !text-sm font-semibold';

export const StyledButtonNotificationIndicator = forwardRef<HTMLSpanElement, HTMLAttributes<HTMLSpanElement>>(
  ({ className, ...props }, ref) => (
    <span ref={ref} className={cn(notificationIndicatorStyles, 'absolute -top-2 -right-2', className)} {...props} />
  )
);
StyledButtonNotificationIndicator.displayName = 'StyledButtonNotificationIndicator';
